import * as Config from '../../../config';
import React from 'react';
import './Footer.css';
import dayjs from 'dayjs';

import Linkage from '../common/Linkage';
import ISFacebookV2 from '../svg/ISFacebookV2';
import ISTwitterV2 from '../svg/ISTwitterV2';
import ISInstagramV2 from '../svg/ISInstagramV2';
import ISTiktokV2 from '../svg/ISTiktokV2';
import ISYoutubeV2 from '../svg/ISYoutubeV2';
import ISDiscordV2 from '../svg/ISDiscordV2';

import LogoLink from '../custom/-APP_TARGET/svg/LogoLink';

function FooterV2() {
  return (
    <div className={`flexRow footer-v2 space-between`}>
      <div className={`flexColumn f-block-left space-between`}>
        <div className={`flexColumn`} style={{gap: 28}}>
          <LogoLink className={'footer-logo'} />
          <div className={`flexRow align`} style={{gap: 16}}>
            <ISFacebookV2 className={`icon-social-v2-fill`} to={Config.S_FACEBOOK} />
            <ISTwitterV2 className={`icon-social-v2-stroke`} to={Config.S_TWITTER} />
            <ISInstagramV2 className={`icon-social-v2-fill`} to={Config.S_INSTAGRAM} />
            <ISTiktokV2 className={`icon-social-v2-fill`} to={Config.S_TIKTOK} />
            <ISYoutubeV2 className={`icon-social-v2-fill`} to={Config.S_YOUTUBE} />
            <ISDiscordV2 className={`icon-social-v2-fill`} to={Config.S_DISCORD} />
          </div>
        </div>
        <span className={`copyright-v2 type-small type-placeholder`}>© {dayjs().format(`YYYY`)} {Config.capAppName()}, LLC</span>
      </div>
      <div className={`flexRow`} style={{gap: 8, marginRight: 30}}>
        <div className={`f-block-right-no-border flexColumn `}>
          <a href={Config.F_CONTACT} target={`_blank`} rel="noopener noreferrer" className={`f-link type-small`} >Contact Us</a>
          { !Config.F_FAQ 
            ? <Linkage label={`FAQ`} to={`/FAQ`} linkClassName={`f-link type-small`} style={{marginTop: 6}} />
            : <a href={Config.F_FAQ} target={`_blank`} rel="noopener noreferrer" className={`f-link type-small`} >FAQ</a>
          }
          { Config.F_RELEASE_NOTES && <a href={Config.F_RELEASE_NOTES} target={`_blank`} rel="noopener noreferrer" className={`f-link type-small`} >Release Notes</a> }
          { Config.F_ABOUT_US && <a href={Config.F_ABOUT_US} target={`_blank`} rel="noopener noreferrer" className={`f-link type-small`} >About {Config.capAppName()}</a> }
          <a href={Config.F_TERMS} target={`_blank`} rel="noopener noreferrer" className={`f-link type-small`} >Terms and Conditions</a>
          <a href={Config.F_POLICY} target={`_blank`} rel="noopener noreferrer" className={`f-link type-small`} >Privacy and Cookie Policy</a>
          <a href={Config.F_COPYRIGHT} target={`_blank`} rel="noopener noreferrer" className={`f-link type-small`} >Report Copyright Infringement</a>
        </div>
        <div className={`f-block-right flexColumn space-between`}>
          <div className='flexColumn'>
            <span className={`f-title-v2 type-regular`}>Connect your controller</span>
            <span className={`f-note-v2 type-small`}>
              Beatport DJ is compatible with most <a href={Config.F_FAQ_HARDWARE} target={`_blank`} rel="noopener noreferrer" className={`f-link fl-footer-v2 type-small`} >MIDI devices</a> and offers fully customizable audio settings to match your hardware.
            </span>
          </div>
          <a href={`https://www.youtube.com/watch?si=2nVz1OAeDnE4Cwar&v=K25gJ0lTAMc&feature=youtu.be`} target={`_blank`} rel="noopener noreferrer" style={{textAlign: 'end'}} className={`f-link type-small`} >Watch Tutorial &gt;</a>
        </div>
        <div className={`f-block-right flexColumn space-between `}>
          <div className='flexColumn'>
            <span className={`f-title-v2 type-regular`}>Transfer your playlists</span>
            <span className={`f-note-v2 type-small`}>
              Transfer your favorite playlists from other streaming services with just a few clicks using Soundiiz or TuneMyMusic.
            </span>
          </div>
          <div style={{marginBottom: 5}}>
            <a href="https://soundiiz.com/partner/beatport" target={`_blank`} rel="noopener noreferrer" className={`f-link type-small`} style={{paddingLeft: 32}} >Soundiiz &gt;</a>
            <a href="https://www.tunemymusic.com/transfer?mode=beatport" target={`_blank`} rel="noopener noreferrer" className={`f-link type-small`} style={{marginLeft: -16}} >TuneMyMusic &gt;</a>
          </div>      
        </div>
      </div>
    </div>
  )
}

export default FooterV2;
